import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// import locale from 'element-ui/lib/locale/lang/zh-CN'; // lang i18n
import '@/icons'; // icon
import '@/styles/index.scss'; // global css
import axios from 'axios';
import 'normalize.css/normalize.css';
// import vCharts from 'v-charts';
// import eCharts from 'echarts';
// import  'lib-flexible/flexible';
// import G2 from '@antv/g2';
import viser from "viser-vue";
import '@/permission' // permission control
import VueAMap from "vue-amap";
import formValidation from "./utils/regular.js"  //导入js所在文件夹
Vue.prototype.formValidation=formValidation; //挂载到原型上
Vue.use(VueAMap);
Vue.use(viser)
// Vue.use(G2)
Vue.config.productionTip = false;
axios.defaults.withCredentials=true;
// Vue.use(ElementUI,{locale});
// Vue.use(vCharts);
// Vue.prototype.$echarts = eCharts ;

//全局定义输入框的特殊字符处理
Vue.prototype.validForbid = function (value) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
  return value;
 }


 Vue.directive('enterNumber', {
  inserted: function (el) {
    el.addEventListener("keypress",function(e){
      e = e || window.event;
      let charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode;
      let re = /\d/;
      if(!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey){
        if(e.preventDefault){
          e.preventDefault();
        }else{
          e.returnValue = false;
        }
      }
    });
  }
})


window._AMapSecurityConfig = {
  securityJsCode: "507574c4e737e6fbf76d2bb64e4881ff",
};

VueAMap.initAMapApiLoader({
  // key: '7955a7d6d910f9c3a659d5134926b485',
  key: 'a35a91c819c28375a2767e98c8328723',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor','AMap.Geocoder','AMap.Geolocation','AMap.MarkerClusterer'],
  // 默认高德 sdk 版本为 1.4.4
  v:'1.4.4'
});
new Vue({
  router,
  store,
  VueAMap,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js